<template>
    <b-form>
        <app-collapse>
            <template v-for="(report, name) in formData.reports">
                <app-collapse-item :title="report.name">
                    <report-download-form :initial-object="report" :report-object="report" @form-data-changed="(reportData) => { formData.reports[name] = reportData; $emit('form-data-changed', formData )}"></report-download-form>
                </app-collapse-item>
            </template>
        </app-collapse>
    </b-form>
</template>

<script>
    import { BButton, BFormInput, BFormGroup, BForm } from 'bootstrap-vue'
    import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
    import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
    import { ref } from '@vue/composition-api'

    import ReportDownloadForm from "../../../base_report/components/reportDownloadForm/ReportDownloadForm";



    export default {

        components: {
            ReportDownloadForm,

            AppCollapse,
            AppCollapseItem,

            BForm,
            BFormInput,
            BFormGroup,
            BButton,

        },

        props: {
            reportObject: {
                type: Object,
                required: true,
            },
        },

        setup(props) {

            const formData = ref(JSON.parse(JSON.stringify({...props.reportObject})));


            return {
                formData,
            }

        }

    }

</script>
